import UserRole from '../enums/UserRole';

export default function userRole(input: string): string {

    switch(input) {

        case UserRole.GROWER: return 'Mosselkweker';
        case UserRole.ADMIN: return 'Admin';
        case UserRole.VIEWER: return 'Bekijker';
        default: return '';
    }
}
